export default async function CreateTimesheetApi(planId, startTime, endTime, workDate, description = '') {
  let res = "";
  try {
    const body = {
      planId,
      startTime,
      endTime,
      workDate,
      description
    };
    
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/timesheets`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error creating timesheet: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
